module.exports = __webpack_public_path__ + "static/media/r+v.2714a62e.svg";